module.exports = __webpack_public_path__ + "img/image-loader.b9e65b3e.gif";